<app-navigation-desktop *ngIf="isDesktop; else mobileNavigation" [isOpen]="isOpen"></app-navigation-desktop>

<ng-template #mobileNavigation>
  <app-navigation-mobile></app-navigation-mobile>
</ng-template>
